export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Открыть диспут"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отменить"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Модератор подключится и поможет разобраться. Пожалуйста, укажите причину и приложите доказательства."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить модератору"])}
}